<template>
  <div class="Kanit">
    <v-container>
      <div v-if="loading" class="text-center" style="margin-top: 88px">
        <Loading></Loading>
      </div>
      <div v-else>
        <div style="text-align: center; position: relative" class="py-2 mb-3">
          <div
            v-if="isCustomerProfile"
            style="position: absolute; top: 0px; left: 0px"
          >
            <v-btn @click="query.view = 'CustomerProfile'" text class="pl-0">
              <v-icon class="mr-2">mdi-chevron-left</v-icon>BACK
            </v-btn>
          </div>
          <img style="height: 50%; width: 64px" src="../assets/logo.svg" />
        </div>
        <div class="text-center">
          <h2 class="mb-3" style="color: #0a4ea2">ตะกร้าสินค้า</h2>
        </div>
        <div v-if="data.length" class="pb-7">
          <div v-for="(item, k) in data" :key="k" class="mb-2">
            <v-card flat class="pa-1">
              <v-row>
                <v-col class="pa-0" cols="4">
                  <div v-if="item.image" style="padding: 7px">
                    <v-img
                      lazy-src="../assets/whiteimg.jpg"
                      :src="item.image"
                      @error="() => (item.image = null)"
                      style="height: 100%"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </div>
                  <div v-else>
                    <div
                      style="
                        height: 100px;
                        width: 100px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                      "
                    >
                      <v-icon>mdi-block-helper</v-icon>
                    </div>
                  </div>
                </v-col>
                <v-col class="py-4 pl-0 pr-1" cols="8">
                  <div style="font-weight: bold; font-size: 13px">
                    {{ item.sales_text_th }}
                  </div>
                  <div>
                    <div>
                      <v-chip
                        v-if="item.shade"
                        x-small
                        :dark="
                          setContrast(item.color ? item.color : '').text ==
                          'white'
                        "
                        :color="`rgb(${item.color})`"
                        >{{ item.shade }}</v-chip
                      >
                      <v-chip
                        v-if="item.film_type"
                        class="ml-2"
                        x-small
                        :dark="
                          setContrast(item.film_type ? item.film_type : '')
                            .text == 'white'
                        "
                        color="primary"
                        >ฟิล์ม: {{ item.film_type }}</v-chip
                      >
                    </div>
                    <v-row>
                      <v-col cols="6">
                        <div
                          class="text-center"
                          style="display: inline-block; width: 100%"
                        >
                          <div style="font-size: 13px">จำนวน</div>
                          <number-input
                            size="small"
                            v-model="item.quantity"
                            :min="1"
                            inline
                            center
                            controls
                          ></number-input>
                        </div>
                      </v-col>
                      <v-col cols="6" class="pl-0">
                        <div class="text-center" style="font-size: 12px">
                          ขนาด
                        </div>
                        <div class="text-center">
                          <span
                            class="px-2"
                            style="
                              background-color: rgb(234 233 233);
                              color: black;
                              font-size: 14px;
                              border-radius: 6px;
                            "
                            >{{ item.size ? item.size : "-" }}</span
                          >
                        </div>
                      </v-col>
                    </v-row>

                    <div
                      style="font-size: 11px; color: red"
                      @click="removeProduct(k)"
                    >
                      <v-icon style="font-size: 18px; color: red"
                        >mdi-trash-can-outline</v-icon
                      >ลบสินค้าออกจากตะกร้า
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </div>
        <div v-else>
          <div class="text-center">
            <v-icon
              style="
                color: #d4d4d4;
                margin-top: 47px;
                font-size: 86px;
                margin-bottom: 20px;
              "
              >mdi-cart-off</v-icon
            >
          </div>
        </div>
        <div
          v-if="data.length"
          @click="saveProduct"
          v-ripple
          class="addcartbtn Kanit myshadow"
        >
          <p v-if="!saveloading">บันทึก</p>
          <div v-else>
            <v-progress-circular
              indeterminate
              size="35"
              color="white"
            ></v-progress-circular>
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import VueNumberInput from "@chenfengyuan/vue-number-input";
import axios from "axios";
import Loading from "@/components/Loading.vue";
export default {
  components: {
    Loading,
    NumberInput: VueNumberInput,
  },
  data() {
    return {
      loading: true,
      saveloading: false,
      input: {
        quantity: 0,
      },
      data: [],
    };
  },
  mounted() {
    this.getProducts();
  },
  computed: {
    isCustomerProfile() {
      return this.$store.state.redirect == "CustomerProfile" ? true : false;
    },
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
  },
  methods: {
    setContrast(myrgb) {
      var rgb = myrgb.split(",");

      // Randomly update colours
      const brightness = Math.round(
        (parseInt(rgb[0]) * 299 +
          parseInt(rgb[1]) * 587 +
          parseInt(rgb[2]) * 114) /
          1000
      );
      const textColour = brightness > 185 ? "black" : "white";
      const backgroundColour =
        "rgb(" + rgb[0] + "," + rgb[1] + "," + rgb[2] + ")";
      return { text: textColour, background: backgroundColour };
    },
    getProducts() {
      var vm = this;
      axios
        .get("https://communitybotbyzwizai.herokuapp.com/toacarts", {
          headers: {
            AUTHORIZATION: "Bearer xxx xxx",
          },
          params: {
            userid: vm.$store.state.userid,
            apptype: vm.query.apptype,
            pageid: vm.query.pageid,
          },
        })
        .then(async (response) => {
          if (response.data && response.data.responsecode == 400) {
            await vm.$swal.fire({
              icon: "error",
              text: response.data.reason,
            });
            if (vm.$store.state.redirect) {
              vm.query.view = vm.$store.state.redirect;
            } else {
              if (this.query.apptype == "line") {
                await this.$liff.closeWindow();
              } else if (this.query.apptype == "facebook") {
                this.$store.dispatch("messengerClose");
              }
            }
            return;
          }
          if (response.data.responsecode == 200 && response.data.data) {
            vm.data = response.data.data;
          }
          vm.loading = false;
        });
    },
    saveProduct() {
      if (!this.saveloading) {
        var vm = this;
        this.saveloading = true;
        var data = {
          userid: vm.$store.state.userid,
          apptype: vm.query.apptype,
          pageid: this.query.pageid,
          cartlist: this.data,
        };
        axios
          .put("https://communitybotbyzwizai.herokuapp.com/toacarts", data, {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          })
          .then(async (response) => {
            this.saveloading = false;
            if (response.data && response.data.responsecode == 400) {
              await vm.$swal.fire({
                icon: "error",
                text: response.data.reason,
              });
              return;
            } else if (response.data.responsecode == 200) {
              if (vm.isCustomerProfile) {
                vm.$swal.fire({
                  icon: "success",
                  text: "แก้ไขตะกร้าเรียบร้อย",
                });
              } else {
                if (this.query.apptype == "line") {
                  await this.$liff.closeWindow();
                } else if (this.query.apptype == "facebook") {
                  this.$store.dispatch("messengerClose");
                }
              }
            }
          });
      }
    },
    removeProduct(k) {
      var vm = this;
      vm.$swal
        .fire({
          text: "ต้องการลบสินค้านี้จากตะกร้าใช่หรือไม่?",
          showCancelButton: true,
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
        })
        .then((result) => {
          if (result.value) {
            vm.data.splice(k, 1);
            if (vm.data && !vm.data.length) {
              vm.saveProduct();
            }
          }
        });
    },
  },
};
</script>
